<template>
  <el-table-column
    prop="to"
    label="Hova"
    show-overflow-tooltip
    width="190"
  >
    <template slot-scope="scope">
      <span v-if="scope.row.type === 'out'">{{ scope.row.to && scope.row.to.company ? scope.row.to.company.name : scope.row.to.name }}</span>
      <span v-else>{{ scope.row.to && scope.row.to.name }}</span>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'to',
  };
</script>
